import { useEffect, useMemo, useState } from 'react'

import { debounce } from 'lodash'

export const useDebouncedSearch = (
  search: string,
  onSearch: (value: string) => void,
  delay = 500,
) => {
  const [localSearch, setLocalSearch] = useState(search)

  const debouncedSearch = useMemo(
    () =>
      debounce((value: string) => {
        onSearch(value)
      }, delay),
    [onSearch, delay],
  )

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setLocalSearch(event.target.value)
    debouncedSearch(event.target.value)
  }

  useEffect(() => {
    setLocalSearch(search)
  }, [search])

  useEffect(() => {
    return () => {
      debouncedSearch.cancel()
    }
  }, [debouncedSearch])

  return {
    localSearch,
    handleSearchChange: handleChange,
  }
}
